import { __awaiter, __generator } from "tslib";
import { AdditionalInputTypes, CookieHelper, DestinationType, ProductType, ProductTypeHelper, ResponseStatus, SearchMaskGroupType, SearchMaskInputType, SearchServiceReferenceType, SearchServiceResultGroupType, settings, Sorting, store, websiteActions, } from 'ltur-state-engine';
import { differenceInCalendarDays, format } from "date-fns";
import { Calendar } from "helper";
import { VariantsHelper } from "HotelDetails/VariantsHelper";
import UserPaginationCreator from "ltur-state-engine/dist/src/websiteStateEngine/util/UserPaginationCreator";
var Products = /** @class */ (function () {
    function Products() {
    }
    Products.isProductsStatusAnyOf = function (responseStatuses, destinationType) {
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus = state.coreState[coreStateGroup].products.get(destinationType).status;
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.isSuggestionsStatusAnyOf = function (responseStatuses, storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus = state.coreState[coreStateGroup].suggestions.get(storageKey).status;
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.isGroupsStatusAnyOf = function (responseStatuses, destinationType) {
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus = state.coreState[coreStateGroup].groups.get(destinationType).status;
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.isOffersStatusAnyOf = function (responseStatuses, storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus;
        if (productType === ProductType.HOTEL) {
            responseStatus = state.coreState[coreStateGroup].offers.get(storageKey).status;
        }
        else {
            responseStatus = state.coreState[coreStateGroup].flightAlternatives.get(storageKey).status;
        }
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.isVariantsStatusAnyOf = function (responseStatuses, storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus = state.coreState[coreStateGroup].variants.get(storageKey).status;
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.isQueryOptionsStatusAnyOf = function (responseStatuses, storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus = state.coreState[coreStateGroup].queryOptions.get(storageKey).status;
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.isGroupQueryOptionsStatusAnyOf = function (responseStatuses, storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        var state = store.getState();
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var responseStatus = state.coreState[coreStateGroup].groupQueryOptions.get(storageKey).status;
        return responseStatuses && responseStatuses.includes(responseStatus);
    };
    Products.checkRequirementsFulfilled = function (state) {
        return (typeof state !== 'undefined'
            && state !== null
            && typeof state.websiteState.searchMask.searchMaskBundle !== 'undefined'
            && state.websiteState.searchMask.searchMaskBundle !== null
            && typeof state.websiteState.app.url !== 'undefined'
            && state.websiteState.app.url !== null
            && typeof state.websiteState.app.url.context !== 'undefined'
            && state.websiteState.app.url.context !== null
            && typeof state.websiteState.app.translations !== 'undefined'
            && state.websiteState.app.translations !== null);
    };
    Products.getDestinationGroupById = function (state, id) {
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var destinationType = DestinationType.DESTINATION;
        if (Products.isGroupsStatusAnyOf([ResponseStatus.SUCCEED], destinationType)) {
            var packageGroupResponse = state.coreState[coreStateGroup].groups.get(destinationType);
            if (packageGroupResponse.productGroups.length) {
                var topDestinationIndex = packageGroupResponse.productGroups[0].productGroups.map(function (e) { return e.id; }).indexOf(id);
                if (topDestinationIndex >= 0) {
                    return packageGroupResponse.productGroups[0].productGroups[topDestinationIndex];
                }
            }
        }
        return null;
    };
    Products.getDestinationGroupRoot = function (state) {
        var productType = state.websiteState.app.url.context.productType;
        var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
        var destinationType = DestinationType.DESTINATION;
        if (Products.isGroupsStatusAnyOf([ResponseStatus.SUCCEED], destinationType)) {
            var packageGroupResponse = state.coreState[coreStateGroup].groups.get(destinationType);
            return packageGroupResponse.productGroups[0];
        }
        return null;
    };
    Products.createDestinationConfirmedValue = function (productGroups) {
        var productGroupId = productGroups.id;
        if (productGroups.properties
            && productGroups.properties.isLink !== void 0
            && productGroups.properties.isLink === true) {
            productGroupId = productGroups.properties.linkTarget;
        }
        return {
            type: AdditionalInputTypes.GENERATED_GROUP,
            value: productGroups.name,
            group: {
                id: productGroupId,
                name: productGroups.name,
                properties: productGroups.properties
            }
        };
    };
    Products.createDestinationHotelCodeConfirmedValue = function (hotel) {
        return {
            type: SearchServiceResultGroupType.HOTEL,
            value: hotel.name,
            reference: {
                type: SearchServiceReferenceType.HOTEL_CODE,
                value: hotel.code
            },
            attributes: hotel.attributes
        };
    };
    Products.createDestinationCoreQuery = function (productGroups) {
        var productGroupId = productGroups.id;
        if (productGroups.properties
            && productGroups.properties.isLink !== void 0
            && productGroups.properties.isLink === true) {
            productGroupId = productGroups.properties.linkTarget;
        }
        return {
            PRODUCT_GROUPS: [
                productGroupId
            ]
        };
    };
    Products.createDestinationHotelCodeCoreQuery = function (hotel) {
        return {
            HOTEL_CODES: [
                hotel.code
            ]
        };
    };
    Products.createDestinationInputValue = function (flatProductGroup) {
        var result = {
            type: AdditionalInputTypes.GENERATED_GROUP,
            value: flatProductGroup.name,
            group: {
                id: flatProductGroup.id,
                name: flatProductGroup.name,
                properties: flatProductGroup.properties
            }
        };
        return {
            uiValue: flatProductGroup.name,
            value: result
        };
    };
    Products.getTotalPages = function (totalCount) {
        var totalPages = Math.floor(totalCount / 10);
        if (totalCount % 10 !== 0) {
            totalPages += 1;
        }
        return totalPages - 1;
    };
    Products.isStateReadyForProductQuery = function () {
        var state = store.getState();
        return state.websiteState.app.location !== void 0
            && state.websiteState.app.location !== null
            && state.websiteState.app.url !== void 0
            && state.websiteState.app.url !== null
            && state.websiteState.searchMask.searchMaskBundle !== void 0
            && state.websiteState.searchMask.searchMaskBundle !== null
            && state.websiteState.searchMask.searchMaskBundle.initialized !== void 0
            && state.websiteState.searchMask.searchMaskBundle.initialized
            && state.optimizelyState.tourOperatorCodes !== void 0
            && state.optimizelyState.tourOperatorCodes !== null;
    };
    Products.isStateReadyForHotelBaseDataQuery = function () {
        var state = store.getState();
        return state.websiteState.app.location !== void 0
            && state.websiteState.app.location !== null
            && state.websiteState.app.url !== void 0
            && state.websiteState.app.url !== null
            && state.websiteState.app.url.context
            && state.websiteState.app.url.context.productType
            && state.websiteState.app.url.hotelCode
            && state.websiteState.searchMask.searchMaskBundle !== void 0
            && state.websiteState.searchMask.searchMaskBundle !== null
            && state.websiteState.searchMask.searchMaskBundle.initialized !== void 0
            && state.websiteState.searchMask.searchMaskBundle.initialized;
    };
    Products.getProductsAsync = function (destinationType, appendResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var state, productType;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery) {
                    state = store.getState();
                    productType = state.websiteState.app.url.context.productType;
                    if (ProductType.HOTEL == productType) {
                        websiteActions.getHotelProducts(destinationType, appendResponse);
                    }
                    else {
                        websiteActions.getPackageProducts(destinationType, appendResponse);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getSuggestionsAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var state, productType;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery) {
                    state = store.getState();
                    productType = state.websiteState.app.url.context.productType;
                    if (ProductType.HOTEL == productType) {
                        websiteActions.getHotelSuggestions();
                    }
                    else {
                        websiteActions.getPackageSuggestions();
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getGroupsAsync = function (destinationType) {
        return __awaiter(this, void 0, void 0, function () {
            var state, productType;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery) {
                    state = store.getState();
                    productType = state.websiteState.app.url.context.productType;
                    if (ProductType.HOTEL == productType) {
                        Products.getHotelGroups(destinationType);
                    }
                    else {
                        Products.getPackageGroups(destinationType);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getPackageGroups = function (destinationType) {
        if (DestinationType.HOTEL_LIST === destinationType) {
            websiteActions.getPackageGroups(destinationType, null, '?flatGroups=true', { "PHUB_FACETS": ["attributes"] });
        }
        else {
            websiteActions.getPackageGroups(destinationType, null, '?compact=true');
        }
    };
    Products.getHotelGroups = function (destinationType) {
        if (DestinationType.HOTEL_LIST === destinationType) {
            websiteActions.getHotelGroups(destinationType, null, '?flatGroups=true', { "PHUB_FACETS": ["attributes"] });
        }
        else {
            websiteActions.getHotelGroups(destinationType, null, '?compact=true');
        }
    };
    Products.getOffersAsync = function (storageKey, pagination, appendResponse, updateState) {
        if (storageKey === void 0) { storageKey = 'default'; }
        if (updateState === void 0) { updateState = true; }
        return __awaiter(this, void 0, void 0, function () {
            var state, productType, options;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery) {
                    state = store.getState();
                    productType = state.websiteState.app.url.context.productType;
                    options = {};
                    if (this.isLiveUpdatesEnabled()) {
                        options.ENABLE_LIVE_UPDATES = true;
                        options.ENABLE_DYNAMIC_PAGING = true;
                        if (!pagination) {
                            pagination = UserPaginationCreator.create(store.getState(), SearchMaskGroupType.HOTEL);
                            pagination.size = 25;
                            pagination.resumeFromIndex = 0;
                        }
                    }
                    if (ProductType.HOTEL == productType) {
                        Products.getHotelOffers(storageKey, pagination, appendResponse, undefined, options, updateState);
                    }
                    else {
                        Products.getPackageOffers(storageKey, pagination, appendResponse, undefined, options);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getPackageOffers = function (storageKey, pagination, appendResponse, mergeExcludeList, optionalOptions) {
        if (storageKey === void 0) { storageKey = 'default'; }
        // We have to check if a preferred departure date is defined
        var state = store.getState();
        var searchMaskGroupType = SearchMaskGroupType.PACKAGE;
        var searchMaskGroup = state.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
        var preferredDepartureDate = searchMaskInput.confirmedValue.value.preferredDepartureDate;
        if (preferredDepartureDate) {
            websiteActions.getPackageOffers(storageKey, preferredDepartureDate, pagination, 1000, appendResponse, mergeExcludeList, optionalOptions);
        }
        else {
            websiteActions.getPackageOffers(storageKey, undefined, pagination, 1000, appendResponse, mergeExcludeList, optionalOptions);
        }
    };
    Products.getHotelOffers = function (storageKey, pagination, appendResponse, mergeExcludeList, optionalOptions, updateState) {
        if (storageKey === void 0) { storageKey = 'default'; }
        if (updateState === void 0) { updateState = true; }
        // We have to check if a preferred departure date is defined
        var state = store.getState();
        var searchMaskGroupType = SearchMaskGroupType.HOTEL;
        var searchMaskGroup = state.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
        var preferredDepartureDate = searchMaskInput.confirmedValue.value.preferredDepartureDate;
        if (preferredDepartureDate) {
            websiteActions.getHotelOffers(storageKey, preferredDepartureDate, pagination, 1000, appendResponse, mergeExcludeList, optionalOptions, updateState);
        }
        else {
            websiteActions.getHotelOffers(storageKey, undefined, pagination, 1000, appendResponse, mergeExcludeList, optionalOptions, updateState);
        }
    };
    Products.getVariantsAsync = function (startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            var state, productType, searchMaskGroup, searchMaskInput, duration, departureDate, returnDate, preferredDepartureDate, timespan, variantsSize;
            return __generator(this, function (_a) {
                state = store.getState();
                productType = state.websiteState.app.url.context.productType;
                searchMaskGroup = state.websiteState.searchMask.searchMaskBundle.groups[productType];
                searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
                if (!Products.isStateReadyForProductQuery)
                    return [2 /*return*/];
                duration = Calendar.getDurationMinMax(searchMaskInput.confirmedValue.value.duration).durationMax;
                departureDate = startDate || searchMaskInput.confirmedValue.value.departureDate;
                returnDate = endDate || searchMaskInput.confirmedValue.value.returnDate;
                preferredDepartureDate = searchMaskInput.confirmedValue.value.preferredDepartureDate;
                timespan = VariantsHelper.instance.getVariantsRequestTimespan(departureDate, duration, returnDate, startDate ? null : preferredDepartureDate);
                startDate = format(timespan.startDate, 'YYYY-MM-DD');
                endDate = format(timespan.endDate, 'YYYY-MM-DD');
                variantsSize = differenceInCalendarDays(endDate, startDate);
                if (ProductType.HOTEL == productType) {
                    websiteActions.getHotelVariants('default', ['DEPARTURE_DATE'], variantsSize, [Sorting.price, Sorting.startDate], startDate, endDate);
                }
                else {
                    websiteActions.getPackageVariants('default', ['DEPARTURE_DATE'], variantsSize, [Sorting.price, Sorting.startDate], startDate, endDate);
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getPackageFlightAlternativesAsync = function (storageKey, pagination, appendResponse, updateState) {
        if (storageKey === void 0) { storageKey = 'default'; }
        if (updateState === void 0) { updateState = true; }
        return __awaiter(this, void 0, void 0, function () {
            var state, searchMaskGroupType, searchMaskGroup, searchMaskInput, preferredDepartureDate, options;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery) {
                    state = store.getState();
                    searchMaskGroupType = state.websiteState.searchMask.searchMaskActiveTab;
                    searchMaskGroup = state.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
                    searchMaskInput = searchMaskGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
                    preferredDepartureDate = searchMaskInput.confirmedValue.value.preferredDepartureDate;
                    options = {
                        RELAXED_FLIGHT_OFFER_KEY: true,
                        MERGE_SIMILAR_FLIGHTS: true,
                    };
                    if (this.isLiveUpdatesEnabled()) {
                        options.ENABLE_LIVE_UPDATES = true;
                        options.ENABLE_DYNAMIC_PAGING = true;
                        if (!pagination) {
                            pagination = UserPaginationCreator.create(store.getState());
                            pagination.size = 25;
                            pagination.resumeFromIndex = 0;
                        }
                    }
                    if (preferredDepartureDate) {
                        websiteActions.getPackageFlightAlternatives(storageKey, preferredDepartureDate, pagination, 1000, appendResponse, undefined, options, updateState);
                    }
                    else {
                        websiteActions.getPackageFlightAlternatives(storageKey, undefined, pagination, 1000, appendResponse, undefined, options, updateState);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getQueryOptionsAsync = function (storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        return __awaiter(this, void 0, void 0, function () {
            var state, productType;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery) {
                    state = store.getState();
                    productType = state.websiteState.app.url.context.productType;
                    if (ProductType.HOTEL == productType) {
                        websiteActions.getHotelQueryOptions(storageKey);
                    }
                    else {
                        websiteActions.getPackageQueryOptions(storageKey);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.getGroupQueryOptionsAsync = function (storageKey) {
        if (storageKey === void 0) { storageKey = 'default'; }
        return __awaiter(this, void 0, void 0, function () {
            var state, productType;
            return __generator(this, function (_a) {
                if (Products.isStateReadyForProductQuery()) {
                    state = store.getState();
                    productType = state.websiteState.app.url.context.productType;
                    if (ProductType.HOTEL == productType) {
                        websiteActions.getHotelGroupQueryOptions(storageKey);
                    }
                    else {
                        websiteActions.getPackageGroupQueryOptions(storageKey);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Products.checkAvailability = function (offerKey, price) {
        return __awaiter(this, void 0, Promise, function () {
            var context, bookapiBaseUrl, protocol, apiEndpoint, queryParameters;
            return __generator(this, function (_a) {
                context = store.getState().websiteState.app.url.context;
                bookapiBaseUrl = settings.bookApi.host + settings.bookApi.prefix;
                protocol = store.getState().websiteState.app.location.protocol;
                apiEndpoint = settings.bookApi.endPoints.checkCompact;
                queryParameters = new URLSearchParams();
                queryParameters.set("offerKey", offerKey);
                queryParameters.set("client", settings.defaultProductContext.client + "");
                queryParameters.set("market", context.market);
                queryParameters.set("country", context.country);
                queryParameters.set("language", context.language);
                queryParameters.set("currency", context.currency);
                queryParameters.set("productType", context.productType);
                queryParameters.set("productChannel", context.productChannel);
                queryParameters.set("originalPrice", price.amountTotal + "");
                queryParameters.set("originalPricePerPerson", price.amountPerPerson + "");
                return [2 /*return*/, fetch(protocol + '//' + bookapiBaseUrl + apiEndpoint + '?' + queryParameters, {
                        headers: settings.coreApi.defaultPostHeaders,
                        method: 'GET',
                    })];
            });
        });
    };
    Products.isLiveUpdatesEnabled = function () {
        return CookieHelper.isLiveUpdatesEnabled();
    };
    return Products;
}());
export default Products;
